import PropTypes from "prop-types";
import FilterSelector, { FilterOptionProps } from "./FilterSelector/FilterSelector";

export function Filter({
    name,
    header,
    value,
    options,
    onValueChanged,
    placeHolder,
    reference,
    ...props
}) {
    const selectedValue = options.length >= 1 && options[0].value;

    return (
        <FilterSelector
            {...props}
            name={name}
            header={header}
            options={options}
            selectedValue={selectedValue}
            onValueChanged={onValueChanged}
            placeHolder={placeHolder}
            value={value}
            reference={reference}
        />
    );
}

export default function FiltersPanel({ filters, testName }) {
    return (
        <div style={{ display: "grid", gridTemplateColumns: `repeat(${filters.length}, 1fr)` }} data-test-name={testName}>
            {filters.map((filter, i) => (
                <Filter
                    key={i}
                    name={filter.name ?? `Filter_${i}`}
                    header={filter.header}
                    options={filter.options}
                    placeHolder={filter.placeHolder}
                    onValueChanged={filter.onValueChanged}
                    value={filter.value}
                    isDisabled={filter.isDisabled}
                    reference={filter.reference}
                    {...filter.props}
                />
            ))}
        </div>
    );
}

const FilterProps = {
    name: PropTypes.string,
    header: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(FilterOptionProps).isRequired,
    onValueChanged: PropTypes.func.isRequired,
    placeHolder: PropTypes.string,
    value: PropTypes.object,
    reference: PropTypes.object,
};

const FiltersPanelProps = {
    filters: PropTypes.arrayOf(PropTypes.shape(FilterProps)),
    testName: PropTypes.string,
};

Filter.propTypes = FilterProps;
FiltersPanel.propTypes = FiltersPanelProps;
